import { ListLink, ListProps } from "@/components";

export type Props = ListProps;

export const ListTransfer: React.FC<Props> = (props) => {
  return <ListLink {...props} />;
};
